import { Injectable } from '@angular/core';
import { ClientPropertiesObject } from 'src/app/models/tasks/tasks-properties/client-properties/client-properties-object.model';
import { Converter } from '../../converter.interface';
import { isNullOrUndefined } from 'util';
import { StringUtils } from 'src/app/services/utils/string.utils';
import { TaskDetailsProductObject } from 'src/app/models/tasks/tasks-details/tasks-details-product/task-details-product.model';
import { CharacteristicConverter } from '../../characteristics/characteristic.converter';

@Injectable({
    providedIn: 'root'
})
export class TaskDetailsProductConverter implements Converter<TaskDetailsProductObject>{

    public convert(input: any): TaskDetailsProductObject {
        try {
            if (isNullOrUndefined(input)) return TaskDetailsProductObject.create();
            return new TaskDetailsProductObject(StringUtils.default(''),
                StringUtils.default(input.order.process.name), StringUtils.default(input.order.process.id), true);
        } catch (error) {
            console.error(error);
            return TaskDetailsProductObject.create();
        }
    }

}
